module.exports = __webpack_public_path__ + "static/media/visa.8176c0ce.png";